module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('mu-appbar', {
    attrs: {
      "zDepth": 0
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "slot": "left",
      "icon": "arrow_back"
    },
    on: {
      "click": _vm.showSearch
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-text-field', {
    staticClass: "appbar-search-field",
    attrs: {
      "slot": "default",
      "hintText": "...."
    },
    on: {
      "input": _vm.input
    },
    slot: "default",
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "slot": "right",
      "icon": "search"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-list', [_c('mu-sub-header', [_vm._v("在输入框中，输入名字或者Phone搜索好友")]), _vm._v(" "), _vm._l((_vm.friend), function(item) {
    return _c('div', [_c('mu-list-item', {
      attrs: {
        "title": item.name
      },
      on: {
        "click": function($event) {
          return _vm.showPersonindex_x(item._id)
        }
      }
    }, [_c('mu-avatar', {
      attrs: {
        "slot": "leftAvatar",
        "src": item.avatar
      },
      slot: "leftAvatar"
    }), _vm._v(" "), _c('mu-icon', {
      attrs: {
        "slot": "right",
        "value": "chat_bubble"
      },
      slot: "right"
    })], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6798b10e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/search.vue
// module id = 517
// module chunks = 1